/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  //ISSUES
  LOAD_ISSUES,
  LOAD_ISSUES_SUCCESS,
  LOAD_ISSUES_ERROR,




} from "./constants"
//LOAD_ISSUES
export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Issues
export function loadIssues(searchvalue) {
  return {
    type: LOAD_ISSUES,
    searchvalue,
  }
}
export function loadIssuesSuccess(data_copy_details) {
  return {
    type: LOAD_ISSUES_SUCCESS,
    data_copy_details,
  }
}
export function loadIssuesError(error) {
  return {
    type: LOAD_ISSUES_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadIssues,
  loadIssuesSuccess,
  loadIssuesError,

 
  
}

export default actions
